import { useDisplay } from 'vuetify';

export const useScreenSize = () => {
  const display = useDisplay();
  const isMobile = computed(() => display.smAndDown.value);

  return {
    isMobile
  }
}